import gsap from 'gsap'

export const getSessionInfo = function () {
	return fetch('/actions/users/session-info', {
		headers: {
			Accept: 'application/json'
		}
	}).then((response) => response.json())
}

export const isSafariBrowser = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export const isFirefoxBrowser = () => {
  return navigator.userAgent.toLowerCase().includes('firefox');
}

export const setTemplateName = (container) => {
	if (!container.dataset.template) return
	setTimeout(() => {
		document.documentElement.setAttribute('data-template', container.dataset.template)
	}, 200)
}

export const textFilterAnimation = (text) => {
  // Select the necessary SVG filter elements
  const feBlur = document.querySelector(`#svg-filter feGaussianBlur`);
  const feDisplacementMap = document.querySelector(`#svg-filter feDisplacementMap`);

  // Check if required elements exist
  if (!feBlur || !feDisplacementMap) {
    console.warn(`Filter with ID svg-filter not found for element`, text);
    return;
  }

  // Apply the filter to the text element
  text.style.filter = `url(#svg-filter)`;

  // Object to store the values for blur and displacement
  let primitiveValues = { stdDeviation: 0, scale: 0 };
  
  // Set initial opacity to 0
  gsap.set(text, { opacity: 0 });

  // Create the animation timeline
  const animationTimeline = gsap.timeline({
		paused: true,
		once: true,
    defaults: {
      duration: 2.4,
      ease: 'expo',
    },
    // On every update, set the appropriate attributes in the SVG filters
    onUpdate: () => {
      feBlur.setAttribute('stdDeviation', primitiveValues.stdDeviation);
      feDisplacementMap.setAttribute('scale', primitiveValues.scale);
    },
		onComplete: () => {
			text.style.filter = 'none'
		}
  })
  .to(primitiveValues, { 
    startAt: { stdDeviation: 35, scale: 250 },  // Start with a strong blur and high displacement
    stdDeviation: 0,  
    scale: 0 
  }, 0)
  .to(text, { 
    duration: 1.3,
    startAt: {
      opacity: 0,  
      scale: 0.8,
      yPercent: 0
    },
    opacity: 1,  
    scale: 1,
    yPercent: 0  
  }, 0);

	return animationTimeline

}

export default () => {}
